module.exports = __webpack_public_path__ + "img/emotion.cabf64f5.jpg";